import React from 'react'

const Search = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__search ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M14.47 13.369A6.96 6.96 0 0 0 16 9a7 7 0 1 0-7 7 6.96 6.96 0 0 0 4.369-1.53l.611-.49.49-.611zm1.562 1.25l7.82 7.82a.5.5 0 0 1 0 .707l-.706.706a.5.5 0 0 1-.707 0l-7.82-7.82a9 9 0 1 1 1.413-1.413z' />
  </svg>
)

export default Search
